import {ImageUpload} from "../src/imageUpload";
import {Notifications} from "../src/notifications";
import {Profiles} from "../src/profiles";
import SignalR from "../src/signalr";
import Modals from "../src/modals";
import ThemeBuilder from "../src/themebuilder";
import {Clipboard} from "../src/clipboard";
import Emails from "../src/emails";
import {Mask} from "../src/mask";
import {initTooltips} from "../src/tooltips";

let ClubPalPalApp = function () {

    const initFlatPicker = () => {
        document.querySelectorAll("[data-datepicker]").forEach(el => {
            new tempusDominus.TempusDominus(el, {
                localization: {
                    hourCycle: "h23",
                    format: "dd/MM/yyyy"
                },
                display: {
                    viewMode: "calendar",
                    components: {
                        clock: false,
                        hours: false,
                        minutes: false,
                        seconds: false
                    },
                }
            });

            if (el.type === "hidden")
                return;

            const input = el.querySelector("input");
            new Cleave(input, {
                date: true,
                datePattern: ['d', 'm', 'Y'],
                delimiter: '/'
            });
        });

        document.querySelectorAll("[data-datetimepicker]").forEach(el => {
            new tempusDominus.TempusDominus(el, {
                localization: {
                    hourCycle: "h23",
                    format: "dd/MM/yyyy HH:mm"
                },
                display: {
                    viewMode: "calendar",
                    components: {
                        clock: true,
                        hours: true,
                        minutes: true,
                        seconds: false
                    },
                }
            });

            if (el.type === "hidden")
                return;
        });
    }

    const initExternalLinks = () => {
        document.querySelectorAll(".user-content a").forEach(el => {
            el.setAttribute("target", "_blank");
            el.setAttribute("rel", "external nofollow noopener");
        });
    }

    const initTour = () => {
        const tg = new tourguide.TourGuideClient({
            showStepProgress: false,
            showStepDots: false
        });

        if(tg.tourSteps > 0)
            tg.start();
    }

    const initToggleOption = () => {

        document.querySelectorAll("[data-toggle-option]").forEach(el => {
            const selector = el.dataset.toggleOption;
            if(!selector)
                return;

            const bsCollapse = bootstrap.Collapse.getOrCreateInstance(selector, { toggle: false });

            el.addEventListener("change", () => {
                bsCollapse.toggle();
            });
        });
    }

    return {
        init: function () {
            initFlatPicker();
            initExternalLinks();
            initTooltips(document);
            initTour();
            initToggleOption();

            Profiles.init();
            ImageUpload.init();
            Notifications.init();
            ThemeBuilder.init();
            Modals.init();
            Clipboard.init();
            SignalR.init();
            Emails.init();
            Mask.init();
        }
    }
}();

document.addEventListener('DOMContentLoaded', () => {
    ClubPalPalApp.init();
});
